import React from 'react'
import {  DescriptionComponent, FooterComponent, HeaderMobileComponent } from './atoms'
import { useResize } from '../../hooks'
import { Text } from '../'
import { CollectionDetailDiv, ContainerBackground, TitleContainer } from './collection-detail.styled.component'
import { ImagePlaceholderProduct, ASSETS_FOLDER } from '../../assets'
import { FeatureList } from '../../components'
import { store } from '../../effects/store'
import { setMenu } from '../../effects/actions'
const CollectionDetailComponent = ({ onClickExploreAllProducts = () => {}, onClickVisitShowroom = () => {}, collection = null, currentSite }) => {
  const isMobile = useResize().isMobile;

  const onClose = () => {
    store.dispatch(setMenu(false))
  }

  if(collection !== null){
    let image = collection.image ? `${ASSETS_FOLDER}/${collection.image}` : ImagePlaceholderProduct
    return (
      <ContainerBackground image={image}>
        {isMobile && <HeaderMobileComponent title={currentSite} subtitle={collection.name} onClose={() => onClose()} />}
        <CollectionDetailDiv>
            {!isMobile && <TitleContainer>
              <Text className="pr-md-5" fontSize="30px" fontWeight="bold" letterSpacing="1px" fontFamily="" textId={collection.name} titleWithoutTranslate={true} />
            </TitleContainer>}
            <FeatureList sellingPoints={collection.sellingPoints} />
            <DescriptionComponent collection={collection} />
            <FooterComponent onClickExploreAllProducts={onClickExploreAllProducts} onClickVisitShowroom={onClickVisitShowroom}/>
        </CollectionDetailDiv>
      </ContainerBackground>
    )
  }
  return null
};

export default React.memo(CollectionDetailComponent);
